export default __webpack_public_path__ + "static/media/logo.bf26b734.svg";